<template>
    <div>
        <div v-if="!innerIsReview">
            <validation-provider
                v-slot="{ errors }"
                :name="label || 'This'"
                :rules="rules"
                v-bind="providerProps"
                v-show="innerShouldShow"
                :vid="'validate-' + fieldAssignmentId"
            >
                <span
                        class="field-directions"
                        v-if="directions"
                        v-html="directions"
                ></span>
                <div v-if="innerValue && innerValue.length">
                    <v-row dense>
                        <v-col cols="12" md="3">
                            <label>Tier</label>
                        </v-col>
                        <v-col cols="12" md="4">
                            <label>Age Range</label>
                        </v-col>
                        <v-col cols="12" md="4">
                            <label>Price</label>
                        </v-col>
                        <v-col cols="12" md="1"></v-col>
                    </v-row>
                    <v-row v-for="(attr, i) in innerValue" :key="attr.id" dense>
                        <v-col cols="12" md="3">
                            {{ attr.name }}
                        </v-col>
                        <v-col cols="12" md="4">
                            <type-text-box
                                    v-model="attr.sub_title"
                                    v-bind="[componentProps]"
                                    :validation_settings="{}"
                                    :type_attributes="'Single Line'"
                                    :mode="'new'"
                                    :type="'TextBox'"
                                    @change="signalChange"
                                    :fieldAssignmentId="fieldAssignmentId+'-'+i+'-0'"
                            ></type-text-box>
                        </v-col>
                        <v-col cols="12" md="4">
                            <type-money
                                    v-model="attr.retail_price"
                                    v-bind="[componentProps]"
                                    :validation_settings="{required:true}"
                                    :mode="'new'"
                                    :type="'Money'"
                                    @change="signalChange"
                                    :fieldAssignmentId="fieldAssignmentId+'-'+i+'-1'"
                            ></type-money>
                        </v-col>
                        <v-col cols="12" md="1">
                            <v-btn
                                    elevation="0"
                                    class="text-capitalize font-weight-bold bw-btn"
                                    :block="$vuetify.breakpoint.smAndDown"
                                    color="bw-warning"
                                    @click="removeAttr(i)"
                            > <v-icon>mdi-trash-can-outline</v-icon></v-btn>
                        </v-col>
                    </v-row>
                </div>
                <div v-else>
                    <span>No price tiers created. Select "Add Price Tier" below to add one.</span>
                </div>
                <v-btn
                        color="bw-default"
                        class="mb-2"
                        text
                        outlined
                        @click.prevent="attributeDialog = true"
                        :disabled="!attrOptions.length"
                >Add Price Tier</v-btn>
            </validation-provider>
            <v-dialog v-model="attributeDialog" width="280">
                <v-card class="pt-6">
                    <v-card-text class="grey--text text--darken-4">
                        <h4 class="mb-2">
                            Choose a Price Tier
                        </h4>
                        <type-radio
                                v-model="selectedAttr"
                                :type="'Radio'"
                                :value_options="attrOptions"
                                :validation_settings="{}"
                                :mode="'new'"
                        ></type-radio>
                    </v-card-text>

                    <v-card-actions class="grey lighten-4">
                        <v-spacer></v-spacer>
                        <v-btn
                                color="bw-secondary"
                                text
                                @click="attributeDialog = false"
                        >Cancel</v-btn>
                        <v-btn
                                color="bw-secondary"
                                text
                                @click.prevent="attrChosen()"
                                :disabled="!selectedAttr"
                        >Add</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="innerValue && innerValue.length">
                    <v-row dense>
                        <v-col cols="12" md="3">
                            <label>Tier</label>
                        </v-col>
                        <v-col cols="12" md="4">
                            <label>Age Range</label>
                        </v-col>
                        <v-col cols="12" md="4">
                            <label>Price</label>
                        </v-col>
                        <v-col cols="12" md="1"></v-col>
                    </v-row>
                    <v-row v-for="(attr, i) in (innerValue || [])" :key="'attribute-' + i">
                        <v-col cols="12" md="3">{{ attr.name }}</v-col>
                        <v-col cols="12" md="4">{{ attr.sub_title }}</v-col>
                        <v-col cols="12" md="4">${{ attr.retail_price }}</v-col>
                    </v-row>
                </div>
            </type-review>
        </div>
    </div>
</template>

<script>
    import $api from "@api/api";
    import formMixin from '../formMixin'
    import TypeReview from './TypeReview'
    import TypeTextBox from "./TypeTextBox";
    import TypeRadio from "./TypeRadio";
    import TypeMoney from "./TypeMoney";

export default {
    name: 'TypeAttributes',
    mixins: [formMixin],
    components: {
        TypeReview,
        TypeTextBox,
        TypeRadio,
        TypeMoney
    },
    data() {
        return {
            selectedAttr: null,
            attributeDialog: false,
            attributes: []
        }
    },
    async mounted() {
        if( !this.innerValue )
            this.innerValue = [];

        await this.getAttributes();
        this.fieldLoaded(); // signal to the form we are loaded
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                persistentHint: true
            }
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                ...{
                    required:
                        !!this.validation_settings.required &&
                        !!this.innerShouldShow
                }
            } : {}
        },
        attrOptions() {
            return this.attributes.filter(x => !(this.innerValue||[]).find(y => y.attribute_id === x.id));
        }
    },
    methods: {
        async getAttributes() {
            const {data} = await $api.attributes.getAttributes();
            this.attributes = data;
        },
        removeAttr(index) {
            this.innerValue.splice(index, 1);
            this.signalChange();
        },
        attrChosen() {
            if( this.selectedAttr ) {
                let f = this.attributes.find(x => x.id === this.selectedAttr);
                this.innerValue.push({name:f && f.name || '', attribute_id: this.selectedAttr, sub_title:f && f.sub_title || '', sort_order:this.innerValue.length + 1});
                this.selectedAttr = null;
                this.attributeDialog = false;
                this.signalChange();
            }
        },
        signalChange() {
            this.innerValue = [...this.innerValue];
            this.$emit('input', this.innerValue);
        },
    }
}
</script>

<style lang="scss">
    .v-time-picker-clock__hand, .v-time-picker-clock__item--active {
        background-color: #003e52 !important;
    }
</style>
